// src/theme/components.js
export default function getComponents(theme) {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          // boxShadow: 'rgba(255, 255, 255, 0.2) 0px 7px 29px 0px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 5,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.lightGrey.main,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          ".MuiFilledInput-root::after": {
            border: "none",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiFilledInput-root": {
            backgroundColor: theme.palette.lightBlue.main,
            border: "1px solid",
            borderColor: "rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
          },
          "& .MuiSelect-filled::before": {
            border: "none",
          },
          "& .MuiSelect-filled::after": {
            border: "none",
          },
          "& .MuiFilledInput-root::before": {
            border: "none",
          },
          "& .MuiFilledInput-root::after": {
            border: "none",
          },
          "& .MuiFilledInput-root:hover::before": {
            border: "none",
          },
          "& .MuiFilledInput-root:hover": {
            border: "1px solid",
            backgroundColor: theme.palette.lightBlue.main,
          },
          "& .MuiInputLabel-filled": {
            fontWeight: 700,
            color: theme.palette.darkGrey.main,
          },
          "& .MuiFilledInput-root:hover:not(.Mui-disabled):before": {
            border: "none",
          },
          "& .MuiFilledInput-root.Mui-focused": {
            border: "1px solid rgba(0, 0, 0, 0.6)", // Stronger focus border
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          height: "100%",
          display: "flex",
          flexDirection: "row",
          padding: "5px",
        },
      },
    },
    MuiTextField: {
      variants: [
        {
          props: { variant: "soft" }, // Custom variant name
          style: {
            "& .MuiInputBase-root": {
              fontSize: "inherit",
              fontFamily: "inherit",
              padding: 0,
              margin: 0,
              background: "transparent",
              border: "none",
              transition: "border-color 0.2s ease-in-out",
            },
            "& .MuiInputBase-input": {
              padding: 0,
            },
            "& .MuiInput-underline:before, & .MuiInput-underline:after": {
              display: "none", // Remove underline
            },

            // Hover effect
            "&:hover .MuiInputBase-root": {
              borderBottom: "1px solid rgba(0, 0, 0, 0.3)", // Subtle border on hover
            },

            // Focus effect
            "& .MuiInputBase-root.Mui-focused": {
              borderBottom: "1px solid rgba(0, 0, 0, 0.6)", // Stronger focus border
            },

            // Disabled state styling
            "& .MuiInputBase-root.Mui-disabled": {
              opacity: 0.5, // Makes text slightly faded
              cursor: "not-allowed", // Shows the disabled cursor
              borderBottom: "1px dashed rgba(0, 0, 0, 0.2)", // Dashed underline for visual feedback
            },
          },
        },
      ],
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: "1.4rem",
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(33, 43, 70, 0.6)",
        },
        invisible: {
          backgroundColor: "transparent",
        },
      },
    },
  };
}
